import { stateOptions } from '../commonStateTaxData';

export const step1Questions = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'filing_status',
    title: 'Please select filing status:',
    is_required: true,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'single_or_married',
        shortName: 'Single or Married (with two or more incomes)',
      },
      {
        codeValue: 'married_one_income',
        shortName: 'Married (one income)',
      },
      {
        codeValue: 'head_of_household',
        shortName: 'Head of Household',
      },
    ],
  },
];

export const allowancesQuestionsFromData = [
  {
    id: 'yourself',
    title: 'Allowance for yourself',
  },
  {
    id: 'spouse',
    title: 'Allowance for your spouse (if not separately claimed by your spouse)',
  },
  {
    id: 'yourself_blindness',
    title: 'Allowance for blindness (yourself)',
  },
  {
    id: 'spouse_blindness',
    title: 'Allowance for blindness of your spouse (if not separately claimed by your spouse)',
  },
];

export const worksheetQuestions = [
  {
    id: 'dependents',
    title: 'Allowance(s) for your dependents, not including yourself or your spouse',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'additional_amount',
    title: 'Additional amount, if any, you want withheld each pay period (if employer agrees)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
  {
    id: 'link_to_de4',
    title: 'See the California DE-4 for this worksheet',
    question_type: 'link',
    content: 'https://www.edd.ca.gov/pdf_pub_ctr/de4.pdf',
  },
];

// Q1 (a,b,c)
export const withholdingInitialQuestions = [
  {
    id: 'num_regular_withholding_allowances',
    title: 'Number of Regular Withholding Allowances (Worksheet A)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'estimated_deductions_allowances',
    title: 'Estimated Deductions Allowances (Worksheet B)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'total_number_of_allowances',
    title: 'Total Number of Allowances you are claiming',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];

// Q2
export const additionalAmountInitialQuestion = [
  {
    id: 'additional_amount',
    title: 'Additional amount, if any, you want withheld each pay period (if employer agrees), (Worksheet C)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];
